<div class="app_modal-container">
  <div>{{infoText}}</div>

  <div>
    <button @click="() => this.updateShowInfoModal(false)">Close</button>
  </div>
</div>
